function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "value customers users viewer");

var SvgClients = function SvgClients(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    ref: svgRef
  }, props), title === undefined ? _ref2 : React.createElement("title", null, title), React.createElement("path", {
    d: "M362,344.33l9.81-5.18,59.05-31.84,7.09-3.83a32.235,32.235,0,0,1,42.94,11.74L341.73,410.77a97.447,97.447,0,0,1-60.61,8.56l-80.44-14.82a29.933,29.933,0,0,0-21.89,2.91l-43.56,27.54-30.44-99.83.26-.08a52.177,52.177,0,0,0,25.25-12.36l13.33-11.86a89.08,89.08,0,0,1,92.33-9.02l5.52,2.67a63.605,63.605,0,0,0,27.7,6.35h53.53A39.809,39.809,0,0,1,362,344.33Z",
    style: {
      fill: "#f7caa5"
    }
  }), React.createElement("path", {
    d: "M436,194.71v38.94H329.49V189.16a44.265,44.265,0,0,0-7.52-24.75,38.778,38.778,0,0,1,23.48-8.63,33.529,33.529,0,0,0,52.9,1.3,8.184,8.184,0,0,1,1.1-1.24A38.952,38.952,0,0,1,436,194.71Z",
    style: {
      fill: "#dfd400"
    }
  }), React.createElement("path", {
    d: "M430.81,307.22l.05.09-59.05,31.84L362,344.33a39.648,39.648,0,0,0-13-23.57l37.95-20.45,9.66-5.21C408.54,289.05,424.2,295.59,430.81,307.22Z",
    style: {
      fill: "#edb288"
    }
  }), React.createElement("path", {
    d: "M406.35,90.87v17.31a34.61,34.61,0,0,1-69.22,0V90.87a34.61,34.61,0,1,1,69.22,0Z",
    style: {
      fill: "#dfd400"
    }
  }), React.createElement("path", {
    d: "M386.48,299.43l.47.88L349,320.76a39.566,39.566,0,0,0-26.29-9.93H310.84l31.56-17.16A36.47,36.47,0,0,1,386.48,299.43Z",
    style: {
      fill: "#edb288"
    }
  }), React.createElement("path", {
    d: "M321.97,164.41a44.265,44.265,0,0,1,7.52,24.75v64.26H182.67V189.16a44.481,44.481,0,0,1,43.37-44.48,38.307,38.307,0,0,0,60.44,1.49,10.509,10.509,0,0,1,1.25-1.42A44.5,44.5,0,0,1,321.97,164.41Z",
    style: {
      fill: "#e48e66"
    }
  }), React.createElement("path", {
    d: "M295.62,70.53V90.3a39.54,39.54,0,1,1-79.08,0V70.53a39.54,39.54,0,1,1,79.08,0Z",
    style: {
      fill: "#e48e66"
    }
  }), React.createElement("path", {
    d: "M188.49,163.22l1.56,1.39a44.311,44.311,0,0,0-7.38,24.55v44.49H76V194.71a38.943,38.943,0,0,1,37.96-38.93,33.539,33.539,0,0,0,52.91,1.3,8.516,8.516,0,0,1,1.09-1.24A38.71,38.71,0,0,1,188.49,163.22Z",
    style: {
      fill: "#dfd400"
    }
  }), React.createElement("path", {
    d: "M174.87,90.87v17.31a34.61,34.61,0,0,1-69.22,0V90.87a34.61,34.61,0,0,1,69.22,0Z",
    style: {
      fill: "#dfd400"
    }
  }), React.createElement("path", {
    d: "M362.5,356.63c-.091,0-.181,0-.271-.006l-45.651-2.07a219.855,219.855,0,0,0-40.034,1.849,6,6,0,1,1-1.648-11.886,232.479,232.479,0,0,1,42.224-1.952l38.79,1.76a33.813,33.813,0,0,0-33.2-27.5H269.18a70.011,70.011,0,0,1-30.313-6.948l-5.52-2.671a82.763,82.763,0,0,0-85.916,8.268l-13.143,11.694a58.149,58.149,0,0,1-28.15,13.777,6,6,0,1,1-2.176-11.8,46.155,46.155,0,0,0,22.346-10.938l13.334-11.863c.122-.11.25-.213.38-.312a94.72,94.72,0,0,1,98.549-9.629l5.523,2.672a57.927,57.927,0,0,0,25.086,5.751h53.53a45.788,45.788,0,0,1,45.79,45.8,6,6,0,0,1-6,6Z",
    style: {
      fill: "#edb288"
    }
  }), React.createElement("path", {
    d: "M135.23,434.96l14.04,46.05H52.59L31.11,304.85H95.56l9.23,30.28Zm-26.48,15.23a12.89,12.89,0,1,0-12.89,12.89A12.889,12.889,0,0,0,108.75,450.19Z",
    style: {
      fill: "#e48e66"
    }
  }), React.createElement("circle", {
    cx: 95.86,
    cy: 450.19,
    r: 12.89,
    style: {
      fill: "#dfd400"
    }
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgClients, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clients.a7f266bc.svg";
export { ForwardRef as ReactComponent };